import React, { useEffect, useRef, useState } from 'react'
import './ClosureReports.css'
import axios from 'axios'
import { useSelector } from 'react-redux';
import dummyImage from "../../../assets/images/profile.png";
import incubatorLogo from "../../../assets/images/Incubator.png";
import closureNodata from "../../../assets/images/ClosureData.png"
import profile from "../../../assets/images/profile.png";
import { debounce } from 'throttle-debounce';
import moment from 'moment'
import { Calendar } from "primereact/calendar";
import { setLoader } from '../../../erpStore/actions';



function ClosureReports() {

  const [updatedtskList, setUpdatedTskList] = useState([])
  const dStatuses = useSelector((state) => state.data.statusList)
  const [statuses, setStatuses] = useState(dStatuses)
  const stringHeaders = window.localStorage.getItem('myHeaders');
  const storedHeaders = JSON.parse(stringHeaders);
  const url = useSelector((state) => state.data.apiUrl);
  const [closureEmailObj, setClosureEmailObj] = useState([])
  const self = useSelector((state) => state.data.selfData)
  const [taskReportObj, setTaskReportObj] = useState([])
  const [submittedTaskList, setSumittedTaskList] = useState([])
  const [completedTaskList, setCompletedTaskList] = useState([])
  const [pendingTaskList, setPendingTaskList] = useState([])
  const [notStartedTaskList, setNotStartedTaskList] = useState([])
  const [inDiscussionTaskList, setInDiscussionTaskList] = useState([])

  const [senderName, setSenderName] = useState('')
  const [senderDesignation, setSenderDesignation] = useState('')
  const [senderDepartment, setSenderDepartment] = useState('')
  const [closureTime, setClosureTime] = useState('')
  const [searOrDateClosureObj, SetsearOrDateClosureObj] = useState([])
  const [closureByDate, setClosureByDate] = useState()
  const [closureDate, setClosureDate] = useState();
  const [image, setImage] = useState();
  const [emailSendTo, setEmailSendTo] = useState();

  const [notStartedOpt, setNotStartedOpt] = useState(false)
  const [pendingOpt, setPendingOpt] = useState(false)
  const [inDiscussionOpt, setInDiscussionOpt] = useState(false)
  const [SubmittedOpt, setSubmittedOpt] = useState(false)
  const [completedOpt, setCompletedOpt] = useState(false)

  const [onHoverNtStarted, setOnHoverNtStarted] = useState(false)
  const [onHoverPending, setOnHoverPending] = useState(false)
  const [onHoverInDiscussion, setOnHoverInDiscussion] = useState(false)
  const [onHoverSubmitted, setOnHoverSubmitted] = useState(false)
  const [onHoverCompleted, setOnHoverComleted] = useState(false)

  const [toMailStringList, setToMailStringList] = useState([])
  const [ccMailStringList, setCcMailStringList] = useState([])
  const [bccMailStringList, setBccMailStringList] = useState([])

  const [empMobileNo, setMobileNo] = useState()
  const [empMailOff, setEmailOff] = useState()

  const [totalTaskCtn, setTotalTaskCtn] = useState(0)
  const [emailsDisplay, setDisplayEmails] = useState(false)
  const emailDisRef = useRef(null)

  const [closureDtId, setClosureDtId] = useState(null)

  const [crdIndex, setCrdIndex] = useState(null)

  const [calenderFlag, setCalenderFlag] = useState(false)
  const calenderRef = useRef(null)

  const [isEmailCardLoader, setIsEmailCardLoader] = useState(false)

  const [loaderMail, setLoaderMail] = useState(false);
  const [loaderClosureReport, setLoaderCloReport] = useState(false)

  useEffect(() => {
    const today = new Date();
    today.setDate(today.getDate() - 1); // Subtract one day from today's date
    const formatted = today.toISOString().split('T')[0];
    setClosureDate(formatted);
    // Get the year, month, and day components
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
    const day = String(today.getDate()).padStart(2, '0');

    // Format the date as yyyy-mm-dd
    const formattedDate = `${year}-${month}-${day}`;
    setClosureDate(formattedDate)
    setIsEmailCardLoader(true)
    axios.post(`${url}email/search`, { "key": null, 'date': formattedDate }, { headers: storedHeaders })
      .then(response => {
        setClosureEmailObj(response.data)
        setTaskReportObj([])
        setCrdIndex(null)
        setIsEmailCardLoader(false)

      })
      .catch(error => {
        setIsEmailCardLoader(false)
     })
  }, [])

  const handleSearchClosures = (e) => {
    setIsEmailCardLoader(true)
    axios.post(`${url}email/search`, { "key": e, 'date': closureDate }, { headers: storedHeaders })
      .then(response => {
        setClosureEmailObj(response.data)
        setTaskReportObj([])
        setCrdIndex(null)
        setIsEmailCardLoader(false)

      })
      .catch(error => {
        setIsEmailCardLoader(false)
   })
  }


  const formatDate = (date) => {
    const year = date.getFullYear();
    let month = date.getMonth() + 1; // Month indexes are zero-based, so we add 1
    let day = date.getDate();

    // Add leading zero if month or day is less than 10
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;

    return `${year}-${month}-${day}`;
  };

  const handleLimitDate = () => {
    const currentDate = new Date();

    // Subtract 30 days from the current date
    const thirtyDaysAgo = new Date(currentDate);
    thirtyDaysAgo.setDate(currentDate.getDate() - 30);

    // Format the date
    const formattedDate = formatDate(thirtyDaysAgo);
    return formattedDate
  };

  useEffect(() => {
    setClosureEmailObj(searOrDateClosureObj)
  }, [searOrDateClosureObj])


  const timeCalculator = (lastUpdated) => {
    const parsedDate = new Date(lastUpdated);
    const formattedDate = `${parsedDate.getUTCFullYear()}-${(parsedDate.getUTCMonth() + 1).toString().padStart(2, '0')}-${parsedDate.getUTCDate().toString().padStart(2, '0')}T${parsedDate.getUTCHours().toString().padStart(2, '0')}:${parsedDate.getUTCMinutes().toString().padStart(2, '0')}:${parsedDate.getUTCSeconds().toString().padStart(2, '0')}Z`;
    const currentDateTime = new Date();
    const lastUpdatedDateTime = new Date(formattedDate);
    const timeDifference = (currentDateTime - lastUpdatedDateTime) / 1000;

    const secondsInMinute = 60;
    const secondsInHour = 3600;
    const secondsInDay = 86400;
    const secondsInWeek = 604800;
    const secondsInMonth = 2629800;
    const secondsInYear = 31557600;

    if (timeDifference >= secondsInYear) {
      const yearsAgo = Math.floor(timeDifference / secondsInYear);
      return `${yearsAgo} ${yearsAgo === 1 ? 'year' : 'years'} ago`;
    } else if (timeDifference >= secondsInMonth) {
      const monthsAgo = Math.floor(timeDifference / secondsInMonth);
      return `${monthsAgo} ${monthsAgo === 1 ? 'month' : 'months'} ago`;
    } else if (timeDifference >= secondsInWeek) {
      const weeksAgo = Math.floor(timeDifference / secondsInWeek);
      return `${weeksAgo} ${weeksAgo === 1 ? 'week' : 'weeks'} ago`;
    } else if (timeDifference >= secondsInDay) {
      const daysAgo = Math.floor(timeDifference / secondsInDay);
      return `${daysAgo} ${daysAgo === 1 ? 'day' : 'days'} ago`;
    } else if (timeDifference >= secondsInHour) {
      const hoursAgo = Math.floor(timeDifference / secondsInHour);
      return `${hoursAgo} ${hoursAgo === 1 ? 'hr' : 'hrs'} ago`;
    } else {
      const minutesAgo = Math.floor(timeDifference / secondsInMinute);
      return `${minutesAgo} ${minutesAgo === 1 ? 'min' : 'min'} ago`;
    }
  };

  useEffect(() => {
    function handleOutsideClick(event) {
      if (emailDisRef && emailDisRef.current && !emailDisRef.current.contains(event.target)) {
        setDisplayEmails(false)
      } else if (calenderRef && calenderRef.current && !calenderRef.current.contains(event.target)) {
        setCalenderFlag(false)
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
    }
  })
  const debouncedSearchEmployee = debounce(1000, handleSearchClosures);

  useEffect(() => {
    setClosureEmailObj(closureEmailObj)
  }, [closureEmailObj])

  const removeStringParse = (e) => {
    let jsonString = e;
    var jsonObject = null 
    try {
      jsonObject = JSON.parse(jsonString);
    }catch {
      jsonObject = {"editorData" : `${jsonString}`, "plainData" : `${jsonString}`}
    }
  return jsonObject?.editorData
}


function extractPlainText(html) {
  // Replace closing tags with closing tags followed by newline character
  try {
    const replacedHtml = html.replace(/<\/(p|h2|h3|h4)>/g, '</$1>\n');
    // Convert HTML to plain text
    const doc = new DOMParser().parseFromString(replacedHtml, 'text/html');
    return doc.body.textContent || '';
  }catch {
  }
}

  return (
    <div className='closureReport-main-container'>
      <div className='cnt-left-report'>
        <div className='header-closure'>
          <div className='closureReport-heading'>
            <p>Closure Report</p>
            <div className='mailRprtCalHolder'>
              <p style={{ fontFamily: 'Roboto', fontSize: '18px' }}>{closureDate}</p>
              <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }} onClick={() => { setCalenderFlag(true) }}>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.487 1.0466C1.15164 1.09171 0.958482 1.17629 0.817522 1.31737C0.676442 1.45833 0.591709 1.65164 0.546605 1.987C0.500533 2.32954 0.500002 2.78111 0.500002 3.41668V4.08335C0.500002 4.71892 0.500533 5.17048 0.546605 5.51303C0.591709 5.84839 0.676291 6.04154 0.817371 6.1825C0.958331 6.32358 1.15164 6.40832 1.487 6.45342C1.82954 6.49949 2.28111 6.50002 2.91668 6.50002H4.25002C4.88559 6.50002 5.33715 6.49949 5.6797 6.45342C6.01506 6.40832 6.20821 6.32373 6.34917 6.18265C6.49025 6.04169 6.57499 5.84839 6.62009 5.51303C6.66616 5.17048 6.66669 4.71892 6.66669 4.08335V3.41668C6.66669 2.78111 6.66616 2.32954 6.62009 1.987C6.57499 1.65164 6.4904 1.45848 6.34932 1.31752C6.20836 1.17644 6.01506 1.09171 5.6797 1.0466C5.33715 1.00053 4.88559 1 4.25002 1H2.91668C2.28111 1 1.82954 1.00053 1.487 1.0466ZM2.89787 0.5H4.26883C4.88137 0.499995 5.3666 0.499991 5.74635 0.551065C6.13708 0.603617 6.45338 0.714335 6.70273 0.963817C6.95231 1.21319 7.06307 1.52954 7.11563 1.92035C7.1667 2.30009 7.1667 2.78532 7.16669 3.39786V4.10216C7.1667 4.71471 7.1667 5.19993 7.11563 5.57968C7.06307 5.97045 6.95234 6.28677 6.7028 6.53613C6.45344 6.78567 6.13712 6.8964 5.74635 6.94896C5.3666 7.00003 4.88138 7.00003 4.26883 7.00003H2.89786C2.28532 7.00003 1.80009 7.00003 1.42035 6.94896C1.02954 6.8964 0.713191 6.78565 0.463817 6.53606C0.214335 6.28671 0.103617 5.97041 0.0510647 5.57968C-9.38777e-06 5.19993 -5.17778e-06 4.7147 1.07185e-07 4.10216V3.39787C-5.17778e-06 2.78532 -9.38777e-06 2.30009 0.0510647 1.92035C0.103622 1.52958 0.214357 1.21326 0.463892 0.963892C0.713255 0.714357 1.02958 0.603622 1.42035 0.551065C1.80009 0.499991 2.28532 0.499995 2.89787 0.5Z" fill="black" />
                <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1.91675 0C2.05483 0 2.16676 0.111929 2.16676 0.250001V0.750003C2.16676 0.888075 2.05483 1 1.91675 1C1.77868 1 1.66675 0.888075 1.66675 0.750003V0.250001C1.66675 0.111929 1.77868 0 1.91675 0ZM5.2501 0C5.38817 0 5.5001 0.111929 5.5001 0.250001V0.750003C5.5001 0.888075 5.38817 1 5.2501 1C5.11203 1 5.0001 0.888075 5.0001 0.750003V0.250001C5.0001 0.111929 5.11203 0 5.2501 0ZM0.166748 2.41668C0.166748 2.2786 0.278677 2.16668 0.416749 2.16668H6.75011C6.88818 2.16668 7.00011 2.2786 7.00011 2.41668C7.00011 2.55475 6.88818 2.66668 6.75011 2.66668H0.416749C0.278677 2.66668 0.166748 2.55475 0.166748 2.41668Z" fill="black" />
                <path d="M5.58327 5.08318C5.58327 5.17158 5.54815 5.25637 5.48564 5.31888C5.42312 5.38139 5.33834 5.41651 5.24993 5.41651C5.16153 5.41651 5.07674 5.38139 5.01423 5.31888C4.95172 5.25637 4.9166 5.17158 4.9166 5.08318C4.9166 4.99477 4.95172 4.90999 5.01423 4.84747C5.07674 4.78496 5.16153 4.74984 5.24993 4.74984C5.33834 4.74984 5.42312 4.78496 5.48564 4.84747C5.54815 4.90999 5.58327 4.99477 5.58327 5.08318ZM5.58327 3.74984C5.58327 3.83824 5.54815 3.92303 5.48564 3.98554C5.42312 4.04805 5.33834 4.08317 5.24993 4.08317C5.16153 4.08317 5.07674 4.04805 5.01423 3.98554C4.95172 3.92303 4.9166 3.83824 4.9166 3.74984C4.9166 3.66143 4.95172 3.57665 5.01423 3.51414C5.07674 3.45162 5.16153 3.4165 5.24993 3.4165C5.33834 3.4165 5.42312 3.45162 5.48564 3.51414C5.54815 3.57665 5.58327 3.66143 5.58327 3.74984ZM3.91659 5.08318C3.91659 5.17158 3.88148 5.25637 3.81896 5.31888C3.75645 5.38139 3.67167 5.41651 3.58326 5.41651C3.49485 5.41651 3.41007 5.38139 3.34756 5.31888C3.28504 5.25637 3.24993 5.17158 3.24993 5.08318C3.24993 4.99477 3.28504 4.90999 3.34756 4.84747C3.41007 4.78496 3.49485 4.74984 3.58326 4.74984C3.67167 4.74984 3.75645 4.78496 3.81896 4.84747C3.88148 4.90999 3.91659 4.99477 3.91659 5.08318ZM3.91659 3.74984C3.91659 3.83824 3.88148 3.92303 3.81896 3.98554C3.75645 4.04805 3.67167 4.08317 3.58326 4.08317C3.49485 4.08317 3.41007 4.04805 3.34756 3.98554C3.28504 3.92303 3.24993 3.83824 3.24993 3.74984C3.24993 3.66143 3.28504 3.57665 3.34756 3.51414C3.41007 3.45162 3.49485 3.4165 3.58326 3.4165C3.67167 3.4165 3.75645 3.45162 3.81896 3.51414C3.88148 3.57665 3.91659 3.66143 3.91659 3.74984ZM2.24992 5.08318C2.24992 5.17158 2.2148 5.25637 2.15229 5.31888C2.08978 5.38139 2.00499 5.41651 1.91659 5.41651C1.82818 5.41651 1.7434 5.38139 1.68088 5.31888C1.61837 5.25637 1.58325 5.17158 1.58325 5.08318C1.58325 4.99477 1.61837 4.90999 1.68088 4.84747C1.7434 4.78496 1.82818 4.74984 1.91659 4.74984C2.00499 4.74984 2.08978 4.78496 2.15229 4.84747C2.2148 4.90999 2.24992 4.99477 2.24992 5.08318ZM2.24992 3.74984C2.24992 3.83824 2.2148 3.92303 2.15229 3.98554C2.08978 4.04805 2.00499 4.08317 1.91659 4.08317C1.82818 4.08317 1.7434 4.04805 1.68088 3.98554C1.61837 3.92303 1.58325 3.83824 1.58325 3.74984C1.58325 3.66143 1.61837 3.57665 1.68088 3.51414C1.7434 3.45162 1.82818 3.4165 1.91659 3.4165C2.00499 3.4165 2.08978 3.45162 2.15229 3.51414C2.2148 3.57665 2.24992 3.66143 2.24992 3.74984Z" fill="black" />
              </svg>

              {/* <input id="closureDateInput" type='date' value={closureDate} onChange={handleClosureDate} min={handleLimitDate()} max={new Date().toISOString().split('T')[0]} /> */}

              {calenderFlag &&
                <div className='calender-holder-dashboard' ref={calenderRef}>
                  <Calendar value={new Date(closureDate)} inline onChange={(e) => {
                    const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                    setClosureDate(formattedDate)
                    axios.post(`${url}email/search`, { "key": null, 'date': formattedDate }, { headers: storedHeaders })
                      .then(response => {
                        setClosureEmailObj(response.data)
                        setTaskReportObj([])
                        setCrdIndex(null)
                        setCalenderFlag(false)
                      })
                      .catch(error => {})
                  }} unstyled={false} />
                </div>
              }
            </div>
          </div>
          <div className="closure-search-input">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.32406 0.409885C3.97736 0.139279 4.67756 0 5.38469 0C6.09181 0 6.79201 0.139279 7.44531 0.409885C8.09861 0.680491 8.69222 1.07712 9.19223 1.57714C9.69225 2.07715 10.0889 2.67075 10.3595 3.32406C10.6301 3.97736 10.7694 4.67756 10.7694 5.38469C10.7694 6.09181 10.6301 6.79201 10.3595 7.44531C10.1479 7.95605 9.85935 8.4303 9.50457 8.85187L11.8648 11.2121C12.0451 11.3924 12.0451 11.6846 11.8648 11.8648C11.6846 12.0451 11.3924 12.0451 11.2121 11.8648L8.85188 9.50458C7.88508 10.3183 6.65813 10.7694 5.38469 10.7694C3.95658 10.7694 2.58696 10.2021 1.57714 9.19223C0.567313 8.18241 0 6.81279 0 5.38469C0 3.95658 0.567313 2.58696 1.57714 1.57714C2.07715 1.07712 2.67076 0.680491 3.32406 0.409885ZM5.38469 0.923067C4.79878 0.923067 4.21861 1.03847 3.6773 1.26269C3.13599 1.4869 2.64414 1.81555 2.22984 2.22985C1.39313 3.06656 0.923067 4.20139 0.923067 5.38469C0.923067 6.56798 1.39313 7.70281 2.22984 8.53953C3.06656 9.37624 4.20139 9.8463 5.38469 9.8463C6.56798 9.8463 7.70281 9.37624 8.53953 8.53953C8.95382 8.12523 9.28246 7.63338 9.50668 7.09207C9.7309 6.55076 9.8463 5.97059 9.8463 5.38469C9.8463 4.79878 9.7309 4.21861 9.50668 3.6773C9.28247 3.13599 8.95382 2.64414 8.53953 2.22985C8.12523 1.81555 7.63338 1.4869 7.09207 1.26269C6.55076 1.03847 5.97059 0.923067 5.38469 0.923067Z" fill="#263238" fill-opacity="0.4" />
            </svg>
            <input type='text' placeholder='Search employee name' onChange={(e) => debouncedSearchEmployee(e.target.value)} />
          </div>
        </div>
        <div className='closure-card-container'>
          {closureEmailObj && closureEmailObj.length > 0 ?
            <div className='closure-card-scroller-container'>

              {closureEmailObj && closureEmailObj.length > 0 && closureEmailObj.map((closureObj, index) => (
                <div className='closure-card' style={{ backgroundColor: closureObj.emailReadStatus === 'false' ? '#fff' : 'rgb(240 248 255)' }} onClick={() => {
                  setUpdatedTskList([])
                  setLoaderMail(true)
                  setCrdIndex(index)
                  setSenderName(closureObj.empName)
                  setSenderDesignation(closureObj.empDesignation)
                  setSenderDepartment(closureObj.empDepartment)
                  setClosureTime(closureObj.empEmailTime)
                  setToMailStringList(closureObj.emailSendTo)
                  setCcMailStringList(closureObj.emailSendToCc)
                  setBccMailStringList(closureObj.emailSendToBcc)
                  setClosureDtId(closureObj.emailSendId)
                  setMobileNo(closureObj.empMobile)
                  setEmailOff(closureObj.empEmailOfficial)
                  setLoaderCloReport(true)
                  axios.post(`${url}email/get-closure-mail`, { "emailSendId": closureObj.emailSendId }, { headers: storedHeaders })
                    .then(response => {
                      if (response.request.status === 200) {
                        const statusTasksArray = JSON.parse(response.data.emailBody)
                        setUpdatedTskList(statusTasksArray)
                        setTotalTaskCtn(0)
                        setImage(closureObj.empImageUrl)
                        let totalTasks = 0;
                        statusTasksArray.forEach((list) => {
                          totalTasks += list.taskList.length;
                          setTotalTaskCtn(totalTasks)
                        });
                        setLoaderCloReport(false)
                      }
                    })
                    .catch(error => {
                      setLoaderCloReport(false)
                      setLoaderMail(false)
                    })

                  if (closureObj.emailReadStatus === 'false') {
                    axios.put(`${url}email/update/read`, { "emailLogId": closureObj.emailLogId, "userId": self.userId }, { headers: storedHeaders })
                      .then(response => {
                        if (response.request.status === 200) {
                          closureObj.emailReadStatus = 'true'
                          closureEmailObj[index] = closureObj
                        }
                      })
                      .catch(error => {})
                  }
                }}>
                  <div className='closure-card-img'>
                    <img style={{ height: '40px', borderRadius: '50px', width: '40px' }} src={closureObj.empImageUrl ? closureObj.empImageUrl : profile} alt='/' />
                  </div>
                  <div className='closure-sub-cnt'>
                    <div className='user_clsoure_name'>
                      <strong style={{ color: '#FF8402', fontSize: '15px' }}>
                        {`${closureObj.empName}`}</strong>
                      <strong style={{ marginLeft: '50px', fontSize: '13px' }} title={`${closureObj.empMailDate} ${closureObj.emailSentTime}`}>{timeCalculator(`${closureObj.empMailDate} ${closureObj.empEmailTime}`)}</strong></div>
                    <p style={{ color: 'rgba(38, 50, 56, 0.42)', fontSize: '12px' }}>{`(${closureObj.empDesignation})`}</p>
                    <p style={{ marginTop: '5px', fontSize: '15px' }}>Closure report of {closureObj.empMailDate}</p>
                    <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginTop: '10px' }}>
                      {closureObj.count && closureObj.count.length > 0 && closureObj.count.map((status) => (
                        <div style={{ fontSize: '12px', backgroundColor: status?.statusColorCode ? status?.statusColorCode : null }} className=' rpt-completed rpt-notstarted'>
                          {`${status.statusName}(${status.statusCount})`}
                        </div>
                      ))}
                    </div>
                  </div>

                  {crdIndex === index &&
                    <div className='crdStleDiv' style={{ backgroundColor: closureObj?.emailReadStatus === 'false' ? '#fff' : 'rgb(240 248 255)' }}>

                    </div>
                  }
                </div>
              ))}
            </div> :
            isEmailCardLoader !== true && 
            <div className='No-Work-Report-Found-for-this-date'>
              No Work Report Found for this date
            </div>
          }

          {
            isEmailCardLoader && 
              <div class="loaderIdProjectsLoad">
                      <div class="loader-mail"></div>
              </div>
          }

        </div>
      </div>
      {closureEmailObj && closureEmailObj.length > 0 && updatedtskList.length > 0 &&
        <div className='cnt-right-report'>
          <div className='cnt-rigtht-header'>
            <div className='cnt-header-middle'>
              <div className='cnt-header-left'><img src={image ? image : dummyImage} alt='/' /></div>
              <div className='email-header-content'>
                <p style={{ color: '#2632386b' }}><strong style={{ color: '#FF8402' }}>{`${senderName}`}&nbsp;</strong>{`(${senderDepartment} ${senderDesignation})`}</p>
                <div className='toStringClosure'>
                  {toMailStringList.length > 0 &&
                    <div className='toEmailsDiv'>
                      <p>To: &nbsp;</p>
                      {toMailStringList && toMailStringList.length > 0 && toMailStringList.slice(0, 3).map((toEmail) => {
                        const emailPrefix = toEmail.split('@')[0];
                        return (
                          <div className='toEmailtext'>{emailPrefix.length > 10 && toMailStringList.length !== 1 ? emailPrefix.substring(0, 7) + ', ' : emailPrefix}</div>
                        );
                      })}
                    </div>
                  }
                  {ccMailStringList.length > 0 &&
                    <div className='toEmailsDiv'>
                      <p>&nbsp;cc: &nbsp;</p>
                      {ccMailStringList && ccMailStringList.length > 0 && ccMailStringList.slice(0, 3).map((toEmail) => {
                        const emailPrefix = toEmail.split('@')[0];
                        return (
                          <div className='toEmailtext'>{emailPrefix.length > 10 && ccMailStringList.length !== 1 ? emailPrefix.substring(0, 7) + ', ' : emailPrefix}</div>
                        );
                      })}
                    </div>
                  }

                  {bccMailStringList.length > 0 &&
                    <div className='toEmailsDiv'>
                      <p> &nbsp;bcc: &nbsp;</p>
                      {bccMailStringList && bccMailStringList.length > 0 && bccMailStringList.slice(0, 3).map((toEmail) => {
                        const emailPrefix = toEmail.split('@')[0];
                        return (
                          <div className='toEmailtext'>{emailPrefix.length > 10 && bccMailStringList.length !== 1 ? emailPrefix.substring(0, 7) + ', ' : emailPrefix}</div>
                        );
                      })}
                    </div>
                  }

                  {
                    <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '10px', height: '10px' }} onClick={() => {
                      setDisplayEmails(!emailsDisplay)
                      
                    }}>
                      <path d="M4 6L0.535898 0H7.4641L4 6Z" fill="#263238" />
                    </svg>
                  }

                  {emailsDisplay &&
                    <div className='click-emails' ref={emailDisRef}>
                      <div className='dtoContent'>
                        <div className='dtEmailContenthed'>To: &nbsp;</div>
                        <div className='dtEmailContent'>
                          {toMailStringList.map((toEmail, index) => (
                            <div key={index} className='toEmailtext'>
                              {index > 0 && ','}&nbsp;{toEmail}
                            </div>
                          ))}
                        </div>
                      </div>

                      {ccMailStringList.length > 0 &&
                        <div className='dtoContent'>
                          <div className='dtEmailContenthed'>cc: &nbsp;</div>
                          <div className='dtEmailContent'>
                            {ccMailStringList.map((toEmail, index) => (
                              <div key={index} className='toEmailtext'>
                                {index > 0 && ','}&nbsp;{toEmail}
                              </div>
                            ))}
                          </div>
                        </div>
                      }

                      {bccMailStringList.length > 0 &&
                        <div className='dtoContent'>
                          <div className='dtEmailContenthed'>bcc: &nbsp;</div>
                          <div className='dtEmailContent'>
                            {bccMailStringList.map((toEmail, index) => (
                              <div key={index} className='toEmailtext'>
                                {index > 0 && ','}&nbsp;{toEmail}
                              </div>
                            ))}
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>

            <div className='crossIconCR'>
              <p className='cnt-right-header-crud-para' title={`${closureDate} ${closureTime}`}>{timeCalculator(`${closureDate} ${closureTime}`)}</p>
              <svg width="22" height="22" style={{ marginLeft: '17px', cursor: 'pointer' }} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                setCrdIndex(null)
                setUpdatedTskList([])
                setLoaderMail(false)

              }}>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.12292 10.8745C3.85665 10.6083 3.85665 10.1765 4.12292 9.91028L6.5332 7.5L4.12292 5.08972C3.85665 4.82345 3.85665 4.39175 4.12292 4.12548C4.38919 3.85921 4.82089 3.85921 5.08716 4.12548L7.49744 6.53576L9.90834 4.12486C10.1746 3.8586 10.6063 3.8586 10.8726 4.12486C11.1388 4.39113 11.1388 4.82283 10.8726 5.0891L8.46168 7.5L10.8726 9.9109C11.1388 10.1772 11.1388 10.6089 10.8726 10.8751C10.6063 11.1414 10.1746 11.1414 9.90834 10.8751L7.49744 8.46424L5.08716 10.8745C4.82089 11.1408 4.38919 11.1408 4.12292 10.8745Z" fill="#263238" />
              </svg>
            </div>
          </div>
          <div className='closure-report-template'>
            <div className='closure-report-template-scroller'>
              <div className='closure-report-subject'>Closure report of : {closureDate}</div>
              <div style={{ fontSize: '20px' }} className='closure-report-subject' >Respected Sir, </div>

              <div className='closureReport-task-list'>
                <div style={{ fontSize: '18px', width: 'fit-content', marginLeft: '10px', marginBottom: '10px' }}>Today's Work report is as follows :</div>
                <div style={{ fontSize: '18px', width: 'fit-content', marginLeft: '10px', marginBottom: '10px' }}>TotalTasks : {totalTaskCtn}</div>
                {updatedtskList && updatedtskList.length > 0 && updatedtskList.map((obj, index) => (
                  <div className='closure-rpt-completed'>
                    <div className='rpt-completed' style={{ backgroundColor: obj?.statusColorCode ? `${obj.statusColorCode}` : null }}  >{`${obj.status} (${obj.taskList.length})`}</div>
                    {obj.taskList && obj.taskList.length > 0 && obj.taskList.map((taskObj, index) => (
                      <div key={index} className='closureReportTaskDetailView' style={{ marginLeft: '10px', marginTop: '5px', fontSize: '13px' }}>
                        <div className='closureReportTaskTitle'>
                          <p>{index + 1}.&nbsp;{taskObj.taskTitle}</p>
                        </div>
                        <div className='infogATask'>
                          <div className='closureReportTaskDueDate'>
                            <p style={{ color: 'rgba(38, 50, 56, 0.42)', width: '100%', textAlign: 'left' }}>Task DueDate:&nbsp;</p>
                            <p style={{ width: '100%' }}>{taskObj.taskDueDate}</p>
                          </div>
                          <div className='closureReportTaskOwner'>
                            <p style={{ color: 'rgba(38, 50, 56, 0.42)', width: '100%', textAlign: 'left', }}>{'Task Owner : '}</p>
                            <div className="taskonerinClR">
                              <img style={{ borderRadius: '50px', height: '20px', width: '20px' }} id="taskOwnerImage" src={taskObj.taskOwnerImage ? taskObj.taskOwnerImage : profile} alt="" />
                              <p>{taskObj.taskOwner.empFullName}</p>
                            </div>
                          </div>
                          <div className='closureReportTaskProjectName'><p style={{ color: 'rgba(38, 50, 56, 0.42)', width: '100%', textAlign: 'left' }}>Project Name :&nbsp;</p>{taskObj.projectEntity ? taskObj.projectEntity.projectName : '-'}</div>
                          <div className='closureReportTaskProjectNameTime'>
                            <div className='closureTskStartTime'>
                                <p style={{color: 'rgba(38, 50, 56, 0.42)'}}>Start Time</p>
                                <p>{taskObj.taskTimeFrom !== null ? taskObj.taskTimeFrom : '-'}</p>
                            </div>

                            <div className='closureTskStartTime'>
                              <p style={{color: 'rgba(38, 50, 56, 0.42)'}}>End Time</p>
                              <p>{taskObj.taskTimeTo !== null ? taskObj.taskTimeTo : '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className='closureComments'>
                          <p style={{color: 'rgba(38, 50, 56, 0.42)'}}>task Comments: </p>
                          <div className='actltaskCmt'>{taskObj?.taskComment !== '' ? extractPlainText(removeStringParse(taskObj?.taskComment)) : 'No Comment'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}

                <div className='clt-rpt-rgrd'>
                  <p>Thanks & Regards,</p>
                  <p>{senderName}</p>
                </div>
                <div className='emailSignature  emailSignatureForClosure'>
                  <div className='incubator-logo'><img src={incubatorLogo} alt="" /></div>
                  <div className='middle-div-line'></div>
                  <div className='right-signature-content'>
                    <p style={{ fontSize: '25px', fontWeight: '700', color: 'rgb(69, 69, 69)' }}>{senderName}</p>
                    <p style={{ fontSize: '18px', color: ' rgb(255, 0, 0)', fontWeight: '600' }}>{senderDepartment + " " + senderDesignation}</p>
                    <p style={{ marginTop: '10px', fontSize: '14px', color: '#00000082' }}>{empMobileNo}</p>
                    <p style={{ marginTop: '2px', fontSize: '14px', color: '#00000082' }}>{empMailOff}</p>
                    <p style={{ marginTop: '2px', fontSize: '14px', color: '#00000082' }}><a href='#'>www.biencaps.com</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            loaderClosureReport && 
            <div class="loaderIdProjectsLoad">
              <div class="loaderClosureReportCard"></div>
            </div>
          }
        </div>
      }

      {updatedtskList.length === 0 &&
        <div className='NoData_image'>
          {loaderMail ?
            <div className='loader-mail'></div> :
            <img src={closureNodata} alt='/' />
          }

        </div>
      }
    </div>
  )
}

export default ClosureReports